/** Xóa sessionStorage khi user F5 / reload trang (tránh cache getRequestHeader, menu-state, …). */
export function clearSessionStorageOnBrowserReload(): void {
  const onCongViecDuAn = /^\/cong-viec-du-an(?:\/|$)/.test(window.location.pathname);

  if (onCongViecDuAn) return;
  if (typeof window === 'undefined') return;

  
  const isReload = (() => {
    try {
      const entry = performance.getEntriesByType('navigation')[0] as
        | PerformanceNavigationTiming
        | undefined;
      return entry?.type === 'reload';
    } catch {
      const legacy = (performance as Performance & { navigation?: { type?: number } })
        .navigation;
      return legacy?.type === 1;
    }
  })();

  if (isReload) {
    window.sessionStorage.clear();
  }
}

if (typeof window !== 'undefined') {
 
    clearSessionStorageOnBrowserReload();
}
